import { useMemo } from "react";

import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import RegionsDropdown from "app/pages/sales-intelligence/sub-modules/account-overview/company/components/header/BottomSection/CountrySelection/RegionsDropdown/RegionsDropdown";
import type { CountriesSelectionModalProps } from "app/pages/sales-intelligence/sub-modules/advanced-search/components/shared/CountriesSelectionModal/CountriesSelectionModal";
import { CountryRadioEnum } from "app/pages/sales-intelligence/sub-modules/advanced-search/types/common";
import CountryService, { type ICountryObject } from "app/services/CountryService";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";
import type { IRegionObject } from "app/services/RegionService";

import CountriesDDWithChips from "../CountriesDDWithChips/CountriesDDWithChips";
import { StyledCountriesSelectionModal } from "../VisitsFromSelectionModal/styles";

type VisitsFromSelectionModalProps = Omit<CountriesSelectionModalProps, "renderSelection"> & {
    countries: readonly ICountryObject[];
    regions: readonly IRegionObject[];
};

const VisitsFromSelectionModal = (props: VisitsFromSelectionModalProps) => {
    const { countries, regions, ...rest } = props;

    const countriesWithoutWW = countries.filter((c) => c.id !== WORLDWIDE_COUNTRY_ID);

    const availableRadioOptions = useMemo(() => {
        const availableLocation = {
            [CountryRadioEnum.specific]: countriesWithoutWW.length === 0,
            [CountryRadioEnum.worldwide]:
                typeof countries.find(({ id }) => CountryService.isWorldwideCountry(id)) === "undefined",
            [CountryRadioEnum.regions]: salesSettingsHelper.getAvailableRegions().length === 0,
        };

        return availableLocation;
    }, [countries]);

    return (
        <StyledCountriesSelectionModal
            {...rest}
            availableRadioOptions={availableRadioOptions}
            renderSelection={({ selectedIds, selectedRadio, onSelect }) => {
                if (selectedRadio === CountryRadioEnum.regions) {
                    return (
                        <RegionsDropdown
                            selectedIds={selectedIds.map((item) => item.toString())}
                            availableRegions={salesSettingsHelper.getAvailableRegions()}
                            regions={regions}
                            onSelect={onSelect}
                        />
                    );
                }

                return (
                    <CountriesDDWithChips
                        onSelect={onSelect}
                        countries={countriesWithoutWW}
                        selectedIds={selectedIds.filter((id) => id !== WORLDWIDE_COUNTRY_ID)}
                        isWrapperHidden={selectedRadio === CountryRadioEnum.worldwide}
                    />
                );
            }}
        />
    );
};

export default VisitsFromSelectionModal;
